if ('serviceWorker' in navigator) {
  const baseUrl =
    typeof import.meta !== 'undefined' ? import.meta.env.BASE_URL : '/';
  const swPath = `${baseUrl}service-worker.js`;

  const scope = import.meta.env.BASE_URL || '/';

  window.addEventListener('load', () => {
    console.log('Page loaded, attempting to register Service Worker...');
    console.log(`Service Worker Path: ${swPath}`);
    console.log(`Service Worker Scope: ${scope}`);

    navigator.serviceWorker
      .register(swPath, { scope })
      .then(registration => {
        console.log(
          `Service Worker registered successfully with scope: ${registration.scope}`
        );
      })
      .catch((error: unknown) => {
        console.error('Service Worker registration failed:', error);

        if (error instanceof Error) {
          if (error.name === 'SecurityError') {
            console.error('Ensure the site is served over HTTPS.');
          } else if (error.message.includes('fetch')) {
            console.error(
              'Service worker file might be missing or inaccessible.'
            );
          } else if (error.name === 'TypeError') {
            console.error('Possible incorrect swPath or browser issue.');
          } else {
            console.error('Unhandled Service Worker error:', error);
          }
        } else {
          console.error('An unknown error occurred:', error);
        }
      });
  });
}
export {};
